import React from "react";
import PropTypes from "prop-types";

import "./style.scss";
function BoxDtl(props) {
    const col = [];
    for (let i = 0; i < props.noOfCol; i++) {
        col.push(
            <div className={"grid"} key={`${i}-row`}>
                <div className={"grid-shimmer"} style={{ width: "90%" }}></div>
            </div>
        );
    }
    return <div style={{ display: "flex" }}>{col}</div>;
}
const HeaderShimmer = props => {
    const { noOfCol, noOfRow } = props;
    const row = [];
    for (let i = 0; i < noOfRow; i++) {
        row.push(<BoxDtl noOfCol={noOfCol} />);
    }
    return (
        <div className="table-shimmer-container main-header">
            <div className={"grid grid-shimmer header-grid"} />
            <div className={"header-rows"}>{row}</div>
            <div className={"grid grid-shimmer header-btn"} />
        </div>
    );
};

HeaderShimmer.propTypes = {
    TableRow: PropTypes.bool
};
HeaderShimmer.defaultProps = {
    noOfRow: 2,
    noOfCol: 3
};

export default HeaderShimmer;
